export function getUrl(unformattedUrl: string) {
  return unformattedUrl.replaceAll(' ', '%20');
}
